<div class="color-filter">
  <button (click)="dropdownOpen = !dropdownOpen" class="button button--outline color-filter__button">
    <div class="color-filter__text">
      <ng-container *ngIf="selectedColor === Color.BLACK">
        <div class="black">
          <div></div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedColor === Color.WHITE">
        <div class="white">
          <div></div>
        </div>
      </ng-container>
      <div>
        <span>{{ 'configurator.color-filter.color' | translate }}&nbsp;</span>
        <span *ngIf="selectedColor" class="text--grey">({{selectedColor.title}})</span>
      </div>
    </div>


    <ng-container *ngIf="!dropdownOpen; else showExpandLess">
      <span class="material-symbols-outlined text--grey">expand_more</span>
    </ng-container>
    <ng-template #showExpandLess>
      <span class="material-symbols-outlined text--grey">expand_less</span>
    </ng-template>
  </button>

  <div (click)="updateColor(undefined)" *ngIf="dropdownOpen" class="color-filter__dropdown">
    <label for="undefined">
      <input [(ngModel)]="selectedColor" [value]="undefined" id="undefined" name="color" type="radio">

      <ng-container *ngIf="selectedColor === undefined; else noCheck">
        <div class="color__check">
          <span class="material-symbols-outlined">
            radio_button_checked
          </span>
        </div>
      </ng-container>

      <span>{{ 'configurator.color-filter.all' | translate }}</span>

    </label>

    <label (click)="updateColor(Color.BLACK)" for="black">
      <input [(ngModel)]="selectedColor" [value]="Color.BLACK" id="black" name="color" type="radio">

      <ng-container *ngIf="selectedColor === Color.BLACK; else noCheck">
        <div class="color__check">
          <span class="material-symbols-outlined">
            radio_button_checked
          </span>
        </div>
      </ng-container>

      <div class="color__text">
        <span>{{capitalizeFirstLetter(Color.BLACK.title)}}</span>
      </div>

    </label>


    <label (click)="updateColor(Color.WHITE)" for="white">
      <input [(ngModel)]="selectedColor" [value]="Color.WHITE" id="white" name="color" type="radio">

      <ng-container *ngIf="selectedColor === Color.WHITE; else noCheck">
        <div class="color__check">
          <span class="material-symbols-outlined">
            radio_button_checked
          </span>
        </div>
      </ng-container>

      <div class="color__text">
        <span>{{capitalizeFirstLetter(Color.WHITE.title)}}</span>
      </div>

    </label>
  </div>
</div>

<ng-template #noCheck>
  <div class="color__check">
    <span class="material-symbols-outlined">
      radio_button_unchecked
    </span>
  </div>

</ng-template>

<!--<label
  [tooltip]="'Zwart'" [zIndex]="4"
  class="configurator__color-chooser configurator__color-chooser&#45;&#45;black"
  for="black">
  <input [(ngModel)]="selectedColor" [value]="Color.BLACK" id="black" name="color" type="radio">
  <div class="color__container">
    <div></div>
    <div class="color__check">
      <span class="material-symbols-outlined">
        check
      </span>
    </div>
  </div>
</label>
<label
  [tooltip]="'Wit'" [zIndex]="4"
  class="configurator__color-chooser configurator__color-chooser&#45;&#45;white"
  for="white">
  <input [(ngModel)]="selectedColor" [value]="Color.WHITE" id="white" name="color" type="radio">
  <div class="color__container">
    <div></div>
    <div class="color__check">
      <span class="material-symbols-outlined">
        check
      </span>
    </div>
  </div>
</label>-->
